module.exports = __webpack_public_path__ + "media/assets/img/clint-mckoy-b76340fe24aa10e13086f005bfd3c798.jpg";